import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';


@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss']
})
export class UserDropdownComponent implements OnInit {

  @Input() public user;

  constructor(
    public authService : AuthService
  ) { }

  ngOnInit(): void {
  }

}
